require('./trid-calculator.module.js');
require('./trid-calculator.route.js');
require('./trid-calculator.controller.js');
